<div class="d-flex flex-column justify-content-between h-100">
  <ngx-hm-header></ngx-hm-header>
  <nb-auth-block class="login-form">
    <a
      class="d-block text-center"
      href="/"
    >
      <img
        src="/assets/images/loghi/logo_hm.png"
        style="height: 128px!important;"
      >
    </a>

    <h6 class="my-2 form-text hm-title text-center">Il percorso nascita... nelle tue mani!</h6>
    <p>
      L'app che ti accompagna dall'inizio della gravidanza fino ad un anno dopo il parto.
      <a href="#/public/dashboard/">
        Maggiori informazioni
      </a>
    </p>

    <form
      (ngSubmit)="login()"
      #form="ngForm"
      autocomplete="nope"
    >

      <div
        *ngIf="isLoginOperator || isLoginUndef"
        class="btn-group btn-block"
      >
        <button
          type="button"
          nbButton
          outline
          class="btn btn-group-icon btn-group-divider btn-fixed input-group-prepend"
          (click)="showOperatorLogin()"
        >
          <i class="ion-key"></i>
        </button>
        <button
          type="button"
          nbButton
          outline
          class="btn-block"
          (click)="showOperatorLogin()"
        >
          Accedi come Operatore</button>
      </div>

      <div
        *ngIf="isLoginAdmin || isLoginUndef"
        class="btn-group btn-block"
      >
        <button
          type="button"
          nbButton
          outline
          class="btn  btn-group-icon btn-group-divider btn-fixed input-group-prepend"
          (click)="showAdminLogin()"
        >
          <i class="ion-key"></i>
        </button>
        <button
          type="button"
          nbButton
          outline
          class="btn-block"
          (click)="showAdminLogin()"
        >
          Accedi come amministratore</button>
      </div>

      <div
        *ngIf="isLoginUser || isLoginUndef"
        class="btn-group btn-block"
      >
        <button
          type="button"
          nbButton
          outline
          class="btn  btn-group-icon btn-group-divider btn-fixed input-group-prepend"
          (click)="showUserLogin()"
        >
          <i class="ion-key"></i>
        </button>
        <button
          type="button"
          nbButton
          outline
          class="btn-block"
          (click)="showUserLogin()"
        >
          Accedi come utente</button>
      </div>
      <div
        class="mt-2"
        *ngIf="isLoginOperator"
      >
        <p>
          L'accesso a hAPPyMamma per gli operatori è possibile attraverso il sistema regionale di autenticazione con:
        </p>
        <ul>
          <li>la propria tessera sanitaria attivata (CNS)</li>
          <li>le credenziali SPID terzo livello di sicurezza (SPID 3)</li>
          <li>la Carta di identità elettronica (CIE).</li>
        </ul>
      </div>
      <div
        *ngIf="isLoginOperator"
        class="btn-group btn-block"
      >
        <button
          type="button"
          class="btn  btn-group-icon btn-group-divider btn-fixed input-group-prepend btn-red d-flex align-items-center"
          (click)="openArpaV2Operatore()"
        >
          <i class="ion-card"></i>
        </button>
        <button
          type="button"
          nbButton
          class="btn-block btn-red"
          (click)="openArpaV2Operatore()"
        >
          OPERATORE <span class="d-none d-lg-block mx-1">-</span> <br class="d-block d-lg-none"> AUTENTICAZIONE TRAMITE
          <br class="d-block d-lg-none"> SISTEMA REGIONALE</button>
      </div>

      <div
        class="mt-2"
        *ngIf="isLoginUser"
      >
        <p>
          L'accesso a hAPPyMamma per le utenti è possibile attraverso il sistema regionale di autenticazione con:
        </p>
        <ul>
          <li>la propria tessera sanitaria attivata (CNS)</li>
          <li>le credenziali SPID</li>
          <li>la Carta di identità elettronica (CIE).</li>
        </ul>
        <p>
          L'accesso all'app con le semplici credenziali (Codice Fiscale e password impostata autonomamente) era
          consentito fino al 31.03.2022, termine ultimo dello stato di emergenza prorogato dal D.L. n. 221 del 24
          dicembre 2021.
        </p>
      </div>
      <div
        *ngIf="isLoginUser"
        class="btn-group btn-block"
      >
        <button
          type="button"
          class="btn  btn-group-icon btn-group-divider btn-fixed input-group-prepend btn-red d-flex align-items-center"
          (click)="openArpaV2Cittadino()"
        >
          <i class="ion-card"></i>
        </button>
        <button
          type="button"
          nbButton
          class="btn-block btn-red"
          (click)="openArpaV2Cittadino()"
        >
          UTENTE <span class="d-none d-lg-block mx-1">-</span> <br class="d-block d-lg-none"> AUTENTICAZIONE TRAMITE
          <br class="d-block d-lg-none"> SISTEMA REGIONALE
        </button>
      </div>

      <!-- <div *ngIf="isLoginAdmin || isLoginUser || (isLoginOperator && isDebug)"> -->
      <div *ngIf="isLoginAdmin || isLoginUser">
        <strong
          class="d-block mt-3"
          *ngIf="isLoginAdmin"
        >
          AUTENTICAZIONE CON CREDENZIALI
        </strong>
        <p *ngIf="isLoginAdmin">
          L'accesso a hAPPyMamma con credenziali (indirizzo email e password impostata autonomamente) è possibile agli
          operatori registrati nel sistema che hanno funzioni di amministratore o referente aziendale o di
          zona-distretto.
        </p>
        <!-- <div class="form-group my-4" *ngIf="isLoginAdmin || (isLoginOperator && isDebug)" > -->
        <div class="form-group my-4" *ngIf="isLoginAdmin" >
          <label
            for="input-email"
            class="sr-only"
          >Indirizzo email</label>
          <input
            name="email"
            [(ngModel)]="user.email"
            id="input-email"
            pattern=".+@.+..+"
            class="form-control"
            placeholder="Indirizzo email"
            #email="ngModel"
            [class.form-control-danger]="email.invalid && email.touched"
            autofocus
            [required]="getConfigValue('forms.validation.email.required')"
          >
          <small
            class="form-text error"
            *ngIf="email.invalid && email.touched && email.errors?.required"
          >
            Email obbligatoria
          </small>
          <small
            class="form-text error"
            *ngIf="email.invalid && email.touched && email.errors?.pattern"
          >
            Verifica l'email
          </small>
        </div>
        <div
          class="form-group my-4"
          *ngIf="isLoginUser && isDebug"
        >
          <label
            for="input-email"
            class="sr-only"
          >Username (codice fiscale)</label>
          <input
            name="email"
            [(ngModel)]="user.username"
            id="input-email"
            class="form-control"
            placeholder="Username (codice fiscale)"
            #email="ngModel"
            autofocus
            [required]="getConfigValue('forms.validation.email.required')"
          >
          <small
            class="form-text error"
            *ngIf="email.touched && email.errors?.required"
          >
            Codice Fiscale/Username obbligatorio
          </small>
        </div>

        <!-- <div class="form-group" *ngIf="isLoginAdmin || (isLoginUser && isDebug) || (isLoginOperator && isDebug)"> -->
        <div class="form-group" *ngIf="isLoginAdmin || (isLoginUser && isDebug)">
          <label
            for="input-password"
            class="sr-only"
          >Password</label>
          <input
            name="password"
            [(ngModel)]="user.password"
            type="password"
            id="input-password"
            class="form-control"
            placeholder="Password"
            #password="ngModel"
            [class.form-control-danger]="password.invalid && password.touched"
            [required]="getConfigValue('forms.validation.password.required')"
            [minlength]="getConfigValue('forms.validation.password.minLength')"
            [maxlength]="getConfigValue('forms.validation.password.maxLength')"
          >
          <small
            class="form-text error"
            *ngIf="password.invalid && password.touched && password.errors?.required"
          >
            Password obbligatoria
          </small>
          <small
            class="form-text error"
            *ngIf="password.invalid && password.touched && (password.errors?.minlength || password.errors?.maxlength)"
          >
            Verifica la password. Dovrebbe contenere da {{ getConfigValue('forms.validation.password.minLength') }} a
            {{ getConfigValue('forms.validation.password.maxLength') }} caratteri
          </small>
        </div>

<!--         <div class="form-group accept-group">
          <nb-checkbox
            *ngIf="isLoginAdmin"
            name="rememberMe"
            [(ngModel)]="user.rememberMe"
          >Ricordami</nb-checkbox>
          <a
            *ngIf="isLoginAdmin"
            routerLink="../request-password"
            [queryParams]="{admin: true}"
            routerLinkActive="active"
          >Imposta password</a>
          <a
            *ngIf="false"
            routerLink="../request-password"
            routerLinkActive="active"
          >Imposta password</a>
        </div> -->

        <button
          *ngIf="isLoginAdmin || isDebug"
          [disabled]="submitted || !form.valid"
          nbButton
          class="btn-block"
          [class.btn-pulse]="submitted"
        >
          Accedi
        </button>

      </div>

      <div
        *ngIf="!isLoginUndef"
        class="clearfix  my-4"
      >
        <button
          nbButton
          status="warning"
          class="float-right"
          (click)="resetLogin()"
        >
          Annulla
        </button>
      </div>

      <div
        *ngIf="showMessages.error && errors && errors.length > 0 && !submitted"
        class="alert alert-danger"
        role="alert"
      >
        <div>
          <strong>Accesso negato</strong>
        </div>
        <div *ngFor="let error of errors">{{ error }}</div>
      </div>

      <div
        *ngIf="showMessages.success && messages && messages.length > 0 && !submitted"
        class="alert alert-success"
        role="alert"
      >
        <div>
          <strong>Accesso eseguito</strong>
        </div>
        <div *ngFor="let message of messages">{{ message }}</div>
      </div>

      <div class="clearfix links my-4">
        <a
          class="text-success"
          routerLink="../assistenza"
          routerLinkActive="active"
        >Serve aiuto?</a><br><br>
        <a
          class="text-success"
          routerLink="../../auth/faq"
          routerLinkActive="active"
        >Domande frequenti</a>
      </div>

      <!--nb-card class="col-12 inline-form-card">
      <nb-card-header class="row">
        <div class="col-10">
          ATTENZIONE: NUOVO LAYOUT DELL'INTERFACCIA DI ACCESSO E DEL BACKOFFICE
        </div>
      </nb-card-header>
    </nb-card-->

    </form>

  </nb-auth-block>
  <div class="footer d-flex justify-content-center">
    <div class="app-stores">
      <a
        class="mr-4"
        href="https://play.google.com/store/apps/details?id=it.regione.toscana.happymamma&amp;hl=it&amp;pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
      >
        <img
          src="/assets/badge_google_play.png"
          alt="Get it on Google Play"
          height="40"
        >
      </a>
      <a href="https://itunes.apple.com/us/app/happymamma/id1228624239">
        <img
          src="/assets/badge_apple_store.png"
          alt="Get it on Apple Store"
          height="40"
        >
      </a>
    </div>
  </div>
</div>
